import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Alert from 'reactstrap/lib/Alert';
import Button from 'reactstrap/lib/Button';

import PromptModal from 'Lib/components/modals/PromptModal';
import PreviewingAlert from 'Lib/components/screening/application/components/PreviewingAlert';

const Pay = ({ isViewing, isPreviewing = false, handleSubmit, showSubmitModal, setSubmit, values }) => {
    const [showCaptcha, setCaptcha] = useState(true);

    return (
        <PromptModal
            isOpen={showSubmitModal}
            onClose={() => setSubmit(false)}
            header="Submit Payment"
            body={
                <>
                    <PreviewingAlert show={isPreviewing} />
                    <br />
                    <div>Are you sure you want to submit this application and payment?</div>
                    <br />
                    <Alert color="danger">Please note that the charge will appear as rentvine on your credit card statement.</Alert>
                    <hr />
                    <div style={{ textAlign: '-webkit-center' }}>
                        <ReCAPTCHA
                            sitekey="6LdodqwaAAAAAPK1nxQ-1BEqlKMs8V9ghWDpZLNi"
                            onChange={value => {
                                if (value) {
                                    setCaptcha(false);
                                } else {
                                    setCaptcha(true);
                                }
                            }}
                        />
                    </div>
                </>
            }
            buttons={prompt => {
                if (prompt.isProcessing) {
                    return (
                        <Button color="primary" disabled={true}>
                            Submitting
                        </Button>
                    );
                }

                return (
                    <>
                        {!isPreviewing && (
                            <Button color="primary" disabled={showCaptcha || isViewing ? true : false} onClick={() => handleSubmit(values, prompt)}>
                                Submit
                            </Button>
                        )}
                        <Button color="secondary" onClick={() => setSubmit(false)}>
                            Cancel
                        </Button>
                    </>
                );
            }}
        />
    );
};

export default Pay;
